import { Component, Injector } from '@angular/core';
import { DialogBaseComponent } from "../../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";

@Component({
    selector: 'app-photo-dialog',
    templateUrl: './c.component.html',
    styleUrls: ['./c.component.css'],
    standalone: false
})
export class PhotoDialogComponent extends DialogBaseComponent<any> {

  constructor(protected injector: Injector) {
    super(injector);
  }
 
}
